import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M524-40q-84 0-157.5-32t-128-86.5Q184-213 152-286.5T120-444q0-146 93-257.5T450-840q-18 98 11 192.5T561-482q71 71 165.5 100.5T920-370q-26 144-138 237T524-40Z"
  })
}), "BedtimeFilled");